"use client";

import { useAppMusic } from "@/hooks/use-app-music";

export function AmbientMusicManager() {
  // Initialize the ambient music system
  useAppMusic();

  // This component doesn't render anything, it just manages music
  return null;
}